import request from './request'
import parameters from './parameters'
const http = {
        // app.yantaiche.cn https://carloan.m24bt.ytmykj.com
        // baseURL: window.location.protocol + "//" + window.location.hostname,
        // baseURL: 'https://app.yantaiche.cn',
        baseURL: parameters.baseURL,
        /**
         * methods: 请求
         * @param url 请求地址
         * @param params 请求参数
         */
        get(url, params) {
            const config = {
                method: 'get',
                url: url,
                headers: {
                    'Connection': 'keep-alive' //设置Content-Type为json
                },
            }
            if (params) config.params = params
            return request(config)
        },
        post(url, params) {
            const config = {
                method: 'post',
                url: url,
                headers: {
                    'Content-Type': 'application/json' //设置Content-Type为json
                },
            }
            if (params) config.data = params
            return request(config)
        },
        put(url, params) {
            const config = {
                method: 'put',
                url: url
            }
            if (params) config.params = params
            return request(config)
        },
        delete(url, params) {
            const config = {
                method: 'delete',
                url: url
            }
            if (params) config.params = params
            return request(config)
        }
    }
    //导出
export default http


// WEBPACK FOOTER //
// ./src/utils/http.js